module.exports = __webpack_public_path__ + "static/media/icon_education.012f3895.svg";